const GET_ASSET_TYPE = 'GET_ASSET_TYPE';
const SET_ASSET_TYPE = 'SET_ASSET_TYPE';
const GET_NON_REQUISITION_ASSET_TYPE = 'GET_NON_REQUISITION_ASSET_TYPE';
const SET_NON_REQUISITION_ASSET_TYPE = 'SET_NON_REQUISITION_ASSET_TYPE';

export {
    GET_ASSET_TYPE,
    SET_ASSET_TYPE,
    GET_NON_REQUISITION_ASSET_TYPE,
    SET_NON_REQUISITION_ASSET_TYPE
};
